import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

// Clipped, bordered image frame with VHS grain + scanlines and slow parallax.
export const VHSImage = ({
  src,
  alt,
  className = "",
  imgClassName = "",
  parallax = true,
  border = true,
  stamp,
}) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], parallax ? ["-8%", "8%"] : ["0%", "0%"]);

  return (
    <div
      ref={ref}
      className={`grain relative overflow-hidden bg-espresso ${
        border ? "border border-ink" : ""
      } ${className}`}
    >
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        style={{ y }}
        className={`h-full w-full object-cover grayscale contrast-[1.08] ${imgClassName}`}
      />
      {stamp && (
        <span className="absolute bottom-3 right-3 z-30 font-mono text-[10px] uppercase tracking-widest text-cream/80">
          {stamp}
        </span>
      )}
    </div>
  );
};
